import { REGEX_BET } from 'shared/constants/constants';
import { BetError } from 'shared/constants/shared-enums';
import { CurrencyType } from 'shared/web3';

export const validateBet = (
  value: string,
  currencyName: string,
  balance: number,
  availableCurrencies: CurrencyType[],
): { valid: boolean; error: BetError | null } => {
  if (!currencyName) return { valid: false, error: null };

  const currency = availableCurrencies.find((currency) => currency.symbol === currencyName);
  if (!currency) return { valid: false, error: BetError.INVALID_BET };

  const betValue = Number(value);

  if (!REGEX_BET.test(value)) {
    return { valid: false, error: BetError.INVALID_BET };
  }

  if (!betValue || betValue < currency.minBet) {
    return { valid: false, error: BetError.LOW_BET };
  }

  if (betValue > balance) {
    return { valid: false, error: BetError.LOW_BALANCE };
  }

  return { valid: true, error: null };
};
